const loadNavigationData = async () => {
  try {
    const response = await fetch('/shopping-cart-list.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error loading navigation data:', error);
    return [];
  }
};

const { REACT_APP_BASE_URL } = process.env;
// Function to create navigation data for use in components
const createNavigationData = (data) => {
  return data.map(({ icon, label, navigationURL,}) => ({
    pageName:label,
    displayName:label,
    icon:`${REACT_APP_BASE_URL}${icon}`,
    route:navigationURL,
    isAuth: [],
    target:  '_blank',
    allowedRoles: []
  }));
};

// Default navigation data (will be replaced when JSON loads)
export let navPageData = [
];

// Initialize navigation data
loadNavigationData().then(data => {
  navPageData = createNavigationData(data);
});
